import React, { useEffect , useState} from "react";
import Log from "./Log";
import axios from 'axios';
import './styles/LogHomeBox.css';
import Cookies from "js-cookie";
import { useConfig } from '../contexts/ConfigContext';

//RePPrA
const LogHomeBox = () =>{
    const config = useConfig();
    const[mostrarError, setMostrarError] = useState(false);
    const [itemsLogs, setItemsLogs] = useState([]);

    const API_URL = `${config.API_URL}/api/usuario/`;

    useEffect(() => {
          //Configuramos axios para que añada al header el respectivo token
        axios.interceptors.request.use(
        (config) => {
            const token = Cookies.get('usr');
            if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            console.error(error)
        });

        const cargarListaUsuarios = async () =>{
            try{
                const response = await axios.post(API_URL + "ultimosLogs", {Authorization: true});
                if(response.status == 200){
                    setItemsLogs(response.data.logs);
                }else{
                    setMostrarError(true);
                }
                
            }catch(error){
                setMostrarError(true);
            }
        }

        cargarListaUsuarios();

    },[]);
    if (mostrarError) return(<div><h1 className="LHB-title">No se encontraron modificaciones recientes</h1></div>);
    else return(
        <div className="LogHomeBoxMain">
            <h2>Últimas modificaciones</h2>
            <div className="LogContainer">
                {itemsLogs.map((item) => (
                    <Log user={item.usuario} action={item.accion} dateU={item.hora}/>
                ))}
                
            </div>
        </div>
    );
}


export default LogHomeBox;